import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, alpha, useThemeProps, CircularProgress, Fade, Backdrop } from '@mui/material';
import ErrorMessage from '../api/ErrorMessage.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinLoadable",
  slot: "Root"
});

var LoadableBase = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadableBase, _React$Component);

  var _super = _createSuper(LoadableBase);

  function LoadableBase() {
    var _this;

    _classCallCheck(this, LoadableBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLoader", function () {
      var _this$props = _this.props,
          loading = _this$props.loading,
          slowLoading = _this$props.slowLoading;
      if (!loading || !(slowLoading || slowLoading === undefined)) return null;
      return /*#__PURE__*/React.createElement(CircularProgress, {
        color: "inherit"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderError", function () {
      var _this$props2 = _this.props,
          error = _this$props2.error,
          animateError = _this$props2.animateError;
      if (!error) return null;
      var errorContent = /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error,
        fullWidth: true
      });

      if (typeof animateError === "number" && animateError > 0) {
        return /*#__PURE__*/React.createElement(Fade, {
          in: !!error,
          timeout: animateError
        }, /*#__PURE__*/React.createElement("div", {
          className: "error"
        }, errorContent));
      }

      return errorContent;
    });

    return _this;
  }

  _createClass(LoadableBase, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          loading = _this$props3.loading,
          slowLoading = _this$props3.slowLoading,
          animateLoader = _this$props3.animateLoader,
          children = _this$props3.children,
          fluid = _this$props3.fluid;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(componentRoot.className, {
          loading: loading,
          fluid: fluid
        }, className)
      }, children, /*#__PURE__*/React.createElement(Backdrop, {
        open: loading !== null && loading !== void 0 ? loading : false,
        invisible: !(slowLoading || slowLoading === undefined),
        transitionDuration: typeof animateLoader === "number" && animateLoader > 0 ? loading ? animateLoader : animateLoader * 0.5 : 0
      }, this.renderLoader()), this.renderError());
    }
  }]);

  return LoadableBase;
}(React.Component);

_defineProperty(LoadableBase, "propTypes", {
  loading: propTypes.bool,
  slowLoading: propTypes.bool,
  error: propTypes.any,
  animateLoader: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  animateError: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  fitLoader: propTypes.bool,
  fluid: propTypes.bool,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
});

_defineProperty(LoadableBase, "defaultProps", {
  animateLoader: 600,
  animateError: 400,
  fitLoader: true
});

var LoadableRoot = styled(LoadableBase, componentRoot.styledOptions)(function (_ref) {
  var theme = _ref.theme,
      loading = _ref.loading,
      fitLoader = _ref.fitLoader,
      fluid = _ref.fluid;
  return {
    position: "relative",
    height: fluid ? "100%" : undefined,
    minHeight: fitLoader && loading ? 60 : 0,
    transition: "min-height 400ms ease",
    "> .MuiBackdrop-root": {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: alpha(theme.palette.background.paper, 0.5)
    },
    "> .MuiBackdrop-invisible": {
      opacity: "0 !important"
    },
    "> .error": {
      marginTop: theme.spacing(3)
    }
  };
});
/**
 * A component for indicating the state of data being loaded
 */

var Loadable = function Loadable(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(LoadableRoot, rootProps);
};

var Loadable$1 = Loadable;

export { Loadable$1 as default };
